import { render, staticRenderFns } from "./PrintLabels.vue?vue&type=template&id=2deccb7d&scoped=true"
import script from "./PrintLabels.vue?vue&type=script&lang=js"
export * from "./PrintLabels.vue?vue&type=script&lang=js"
import style0 from "./PrintLabels.vue?vue&type=style&index=0&id=2deccb7d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deccb7d",
  null
  
)

export default component.exports